import React from 'react';
import { PROGRAMS } from '../constants';
import './ProgramSection.css';
import { Briefcase, ExternalLink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/** Map program id → internal route (expand as more program pages are built) */
const PROGRAM_LINKS: Record<string, string> = {
    '10': '/p2mi-bk',
    '03': '/program-inklusi',
    '06': '/program-inklusi',
};

const ProgramSection: React.FC = () => {
    const navigate = useNavigate();

    return (
        <section className="ProgramSection_section">
            {/* Background Pattern */}
            <div className="ProgramSection_bgPattern">
                <div className="ProgramSection_blob1"></div>
                <div className="ProgramSection_blob2"></div>
            </div>

            <div className="container ProgramSection_contentContainer">
                <div className="ProgramSection_header">
                    <span className="ProgramSection_label">Proyek Terpilih</span>
                    <h2 className="ProgramSection_title">11 Program Strategis</h2>
                    <p className="ProgramSection_description">
                        Dalam periode 2019-2026, Lakpesdam telah melaksanakan berbagai program kemitraan untuk pembangunan berkelanjutan, pemberdayaan berbasis nilai inklusif, dan penguatan masyarakat sipil sebagai berikut:
                    </p>
                </div>

                <div className="ProgramSection_grid">
                    {PROGRAMS.map((program) => {
                        const link = PROGRAM_LINKS[program.id];
                        return (
                            <div
                                key={program.id}
                                className={`ProgramSection_card${link ? ' ProgramSection_cardLinked' : ''}`}
                                onClick={link ? () => navigate(link) : undefined}
                                role={link ? 'button' : undefined}
                                tabIndex={link ? 0 : undefined}
                                onKeyDown={link ? (e) => e.key === 'Enter' && navigate(link) : undefined}
                                aria-label={link ? `Lihat halaman ${program.title}` : undefined}
                            >
                                <div className="ProgramSection_cardNumber">{program.id}</div>
                                <div className="ProgramSection_cardContent">
                                    <span className="ProgramSection_clientBadge">
                                        <Briefcase size={14} className="ProgramSection_clientIcon" />
                                        {program.client}
                                    </span>
                                    <h3 className="ProgramSection_cardTitle">{program.title}</h3>
                                    <p className="ProgramSection_cardDesc">{program.description}</p>
                                    {link && (
                                        <span className="ProgramSection_cardLink">
                                            <ExternalLink size={14} /> Lihat Program
                                        </span>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default ProgramSection;
